export default "__VITE_ASSET__jrMh9gQQ__"